export default {
  'dashboardandanalysis.analysis.test': 'Gongzhuan No.{no} shop',
  'dashboardandanalysis.analysis.introduce': 'Introduce',
  'dashboardandanalysis.analysis.total-sales': 'Total Sales',
  'dashboardandanalysis.analysis.day-sales': 'Daily Sales',
  'dashboardandanalysis.analysis.visits': 'Visits',
  'dashboardandanalysis.analysis.visits-trend': 'Visits Trend',
  'dashboardandanalysis.analysis.visits-ranking': 'Visits Ranking',
  'dashboardandanalysis.analysis.day-visits': 'Daily Visits',
  'dashboardandanalysis.analysis.week': 'WoW Change',
  'dashboardandanalysis.analysis.day': 'DoD Change',
  'dashboardandanalysis.analysis.payments': 'Payments',
  'dashboardandanalysis.analysis.conversion-rate': 'Conversion Rate',
  'dashboardandanalysis.analysis.operational-effect': 'Operational Effect',
  'dashboardandanalysis.analysis.sales-trend': 'Stores Sales Trend',
  'dashboardandanalysis.analysis.sales-ranking': 'Sales Ranking',
  'dashboardandanalysis.analysis.all-year': 'All Year',
  'dashboardandanalysis.analysis.all-month': 'All Month',
  'dashboardandanalysis.analysis.all-week': 'All Week',
  'dashboardandanalysis.analysis.all-day': 'All day',
  'dashboardandanalysis.analysis.search-users': 'Search Users',
  'dashboardandanalysis.analysis.per-capita-search': 'Per Capita Search',
  'dashboardandanalysis.analysis.online-top-search': 'Online Top Search',
  'dashboardandanalysis.analysis.the-proportion-of-sales': 'The Proportion Of Sales',
  'dashboardandanalysis.channel.all': 'ALL',
  'dashboardandanalysis.channel.online': 'Online',
  'dashboardandanalysis.channel.stores': 'Stores',
  'dashboardandanalysis.analysis.sales': 'Sales',
  'dashboardandanalysis.analysis.traffic': 'Traffic',
  'dashboardandanalysis.table.rank': 'Rank',
  'dashboardandanalysis.table.search-keyword': 'Keyword',
  'dashboardandanalysis.table.users': 'Users',
  'dashboardandanalysis.table.weekly-range': 'Weekly Range',
};
